(function () {
  'use strict';
  function init() {
    var form = document.querySelector('[data-lance-shipping-form]');
    if (!form || form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    var result = form.querySelector('[data-lance-shipping-result]');
    var button = form.querySelector('button[type="submit"]');
    var route = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var controller = null;
    var generation = 0;
    function signal(name, action) {
      document.dispatchEvent(new CustomEvent('lance:shopping-signal', { detail: { name: name, parameters: { action: action, step: 'cart_shipping' } } }));
    }
    form.elements.country.value = (window.Shopify && Shopify.country) || 'United States';
    if (!form.elements.country.value) form.elements.country.value = 'United States';
    function invalidate() {
      generation += 1;
      if (controller) controller.abort();
      controller = null;
      button.disabled = false;
      if (result.textContent) result.textContent = 'Your cart or destination changed. Request a new estimate.';
    }
    function signature(cart) {
      return JSON.stringify([cart.currency, cart.total_price, cart.items.map(function (item) { return [item.key, item.quantity]; })]);
    }
    async function read(url, options) {
      var response = await fetch(url, Object.assign({ credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: controller.signal }, options));
      if (!/(?:json|javascript)/.test(response.headers.get('content-type') || '')) throw new Error('The shipping service is temporarily unavailable. Please retry.');
      var data = await response.json();
      if (!response.ok) throw new Error(response.status === 422 ? 'Shopify could not quote that destination. Check the country, state/province and postal code, or contact us for shipping help.' : 'The shipping service is temporarily unavailable. Please retry.');
      return data;
    }
    form.addEventListener('input', invalidate);
    document.addEventListener('lance:cart-updated', invalidate);
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      invalidate();
      var requestGeneration = generation;
      controller = new AbortController();
      var timeout = setTimeout(function () { if (controller && requestGeneration === generation) controller.abort(); }, 30000);
      button.disabled = true;
      result.textContent = 'Calculating Shopify rates for your current cart…';
      try {
        var cart = await read(route + 'cart.js');
        if (!cart.item_count) throw new Error('Your cart is empty. Add the exact size and quantity you want, then request an estimate.');
        if (!cart.requires_shipping) throw new Error('The items in this cart do not require shipping.');
        var params = new URLSearchParams();
        ['country', 'province', 'zip'].forEach(function (field) { params.set('shipping_address[' + field + ']', form.elements[field].value.trim()); });
        await read(route + 'cart/prepare_shipping_rates.json?' + params, { method: 'POST' });
        var quote = null;
        for (var attempt = 0; attempt < 10 && quote === null; attempt += 1) {
          if (attempt) await new Promise(function (resolve) { setTimeout(resolve, 1000); });
          if (requestGeneration !== generation) return;
          quote = await read(route + 'cart/async_shipping_rates.json?' + params);
        }
        if (!quote) throw new Error('Shopify is still calculating rates. Please retry in a moment.');
        var current = await read(route + 'cart.js');
        if (signature(current) !== signature(cart)) throw new Error('Your cart changed while rates were calculated. Request a new estimate.');
        if (requestGeneration !== generation) return;
        result.textContent = '';
        if (!Array.isArray(quote.shipping_rates) || !quote.shipping_rates.length) {
          signal('lance_shipping_error', 'no_rates');
          result.textContent = 'No online shipping service is available for this cart and destination. Contact Lance before ordering to confirm shipping options.';
          return;
        }
        var list = document.createElement('ul');
        quote.shipping_rates.forEach(function (rate) {
          var item = document.createElement('li');
          var price = Number(rate.price);
          item.textContent = rate.name + ' — ' + (Number.isFinite(price) ? new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: rate.currency || cart.currency || 'USD' }).format(price) : 'Confirm at checkout');
          list.appendChild(item);
        });
        result.appendChild(list);
        var note = document.createElement('p');
        note.textContent = 'Estimate for ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in your cart. Taxes are not included. Confirm your complete address and final rate at checkout.';
        result.appendChild(note);
        signal('lance_shipping_estimate', 'rates_shown');
      } catch (error) {
        if (requestGeneration === generation) {
          result.textContent = error.name === 'AbortError' ? 'The estimate timed out. Please retry.' : error.message;
          signal('lance_shipping_error', error.name === 'AbortError' ? 'timeout' : 'quote_error');
        }
      } finally {
        clearTimeout(timeout);
        if (requestGeneration === generation) { button.disabled = false; controller = null; }
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
